import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { refreshCache } from './utils/cacheService';


// Page Components
import Homepage from './pages/Homepage';
import StudentDashboard from './pages/StudentDashboard';
import TeacherDashboard from './pages/TeacherDashboard';
import ParentInterface from './pages/ParentInterface';
import ReadingSession from './pages/ReadingSession';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import EmailConfirmation from './pages/EmailConfirmation';
import ResetPassword from './pages/ResetPassword';
import EmailVerificationSuccess from './pages/EmailVerificationSuccess';
import ProfileSetup from './pages/ProfileSetup';
import BuddySelection from './pages/BuddySelection';
import Calibration from './pages/Calibration';
import VoiceAssistant from './pages/VoiceAssistant';
import AdminUpload from './pages/AdminUpload';

// Components
import BrowserCompatibility from './components/common/BrowserCompatibility';
import ProtectedRoute from './components/common/ProtectedRoute';

// Import styles
import './styles/Dashboard.css';

function App() {
  // On browser refresh, clear backend cache and screenshots so a new session starts clean
  useEffect(() => {
    const navEntry = performance.getEntriesByType?.('navigation')?.[0];
    if (navEntry?.type === 'reload') {
      refreshCache().catch((err) => console.warn('Cache refresh on browser reload failed:', err));
    }
  }, []);
 
  return (
    <Router>
      <BrowserCompatibility />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/student" element={
          <ProtectedRoute>
            <StudentDashboard />
          </ProtectedRoute>
        } />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/email-confirmation" element={<EmailConfirmation />} />
        <Route path="/email-verification-success" element={<EmailVerificationSuccess />} />
        <Route path="/profile-setup" element={
          <ProtectedRoute>
            <ProfileSetup />
          </ProtectedRoute>
        } />
        <Route path="/buddy-selection" element={<BuddySelection />} />
        <Route path="/calibration" element={<Calibration />} />
        <Route path="/parent" element={<ParentInterface />} />
        <Route path="/teacher" element={<TeacherDashboard />} />
        <Route path="/reading-session" element={
          <ProtectedRoute>
            <ReadingSession />
          </ProtectedRoute>
        } />
        <Route path="/voice-assistant" element={<VoiceAssistant />} />
        <Route path="/admin/upload" element={<AdminUpload />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;